import {PropsWithChildren} from 'react'

type Props = {
    margin: number
}

const ComponentDivMarginHorizontal = ({ margin, children } :PropsWithChildren<Props>) =>
    <div style={{margin: ` 0px ${margin}px`}}>{ children }</div>

export default ComponentDivMarginHorizontal